import React, {useCallback} from 'react'
import styled from 'styled-components'
import {ObjectState} from 'types'
import {Modal} from 'common/components'
import convertUnit from 'lib/unit'
import GiftShopTemplateMFAInput from './GiftShopTemplateMFAInput'

const StyledModal = styled(Modal)`
  width: 100%;
  max-width: ${convertUnit(335)};
  padding: ${convertUnit(20)};
  text-align: center;
`

interface GiftShopTemplateModalMFAProps {
  stateModal: ObjectState<boolean>
  onCancel?(): void
  onConfirm(code: string): void
  stateLoading: ObjectState<boolean>
  stateError: ObjectState<string>
  stateShowRecovery?: ObjectState<boolean>
  onRecover?(): void
}
export default function GiftShopTemplateModalMFA({
  stateModal,
  onCancel,
  onConfirm,
  onRecover,
  stateError,
  stateLoading,
  stateShowRecovery,
}: GiftShopTemplateModalMFAProps) {
  const [modal, setModal] = stateModal
  const setError = stateError[1]
  const setShowRecovery = stateShowRecovery && stateShowRecovery[1]

  const handleCancel = useCallback(() => {
    setModal(false)
    setError('')
    setShowRecovery && setShowRecovery(false)
  }, [setError, setModal, setShowRecovery])

  return (
    <StyledModal
      visible={modal}
      onBackdropPress={() => {
        handleCancel()
        onCancel && onCancel()
      }}>
      <GiftShopTemplateMFAInput
        onConfirm={onConfirm}
        stateError={stateError}
        stateLoading={stateLoading}
        stateShowRecovery={stateShowRecovery}
        onCancel={() => {
          handleCancel()
          onCancel && onCancel()
        }}
        onRecover={() => {
          handleCancel()
          onRecover && onRecover()
        }}
      />
    </StyledModal>
  )
}
